// used for a grid that contains qty fields that update the price/total price fields

bq.productSourceAmazon = function(element, options) {
    this.$element  = $(element);
    this.options = options;

    if (!this.options.nameContainerSelector) {
        this.options.nameContainerSelector = this.options.defaultContainerSelector;
    }
    if (!this.options.errorContainerSelector) {
        this.options.errorContainerSelector = this.options.defaultContainerSelector;
    }
    if (!this.options.offersContainerSelector) {
        this.options.offersContainerSelector = this.options.defaultContainerSelector;
    }

    this.$priceContainer  = $(this.options.priceContainerSelector, this.$element);

    this.$nameContainer   = $(this.options.nameContainerSelector,  this.$element);
    this.$errorContainer  = $(this.options.errorContainerSelector, this.$element);
    this.$offersContainer = $(this.options.offersContainerSelector,this.$element);

    this.$attributesContainer = null;
    if (this.options.attributesContainerSelector) {
        this.$attributesContainer = $(this.options.attributesContainerSelector,this.$element);
    }

    this.$children        = $(this.options.childrenSelector,       this.$element);

    this.isLoadAllowed = (!!bq.config.ab && !!bq.config.ab.useListAjax);
    this.loadAttempts = 0;
    this.reloadRequests = 0;
    this.qtyChangeTimer = null;

    this.loaded = false;
    this.errorHappened = false;
    this.errorMessage = null;

    this.product = this.getProduct();

    this.sku = this.product.supplier_sku || this.product.sku;
    this.productId = this.product.id || this.product.entity_id;
    this.isAmazon = (!!this.product.source_system && this.product.source_system === 'amazon');
};

bq.productSourceAmazon.DEFAULTS = {
    defaultContainerSelector: '[data-bq-il-type="name"]',
    priceContainerSelector: '[data-bq-il-type="price"]',
    attributesContainerSelector: null,

    childrenSelector: 'input,button',
    qtyInputSelector: '.commonly_ordered_items .amazon-product-grid-row .product-qty',
    qtyChangeDelay: 500,

    errorTemplate: '<div class="text-warning product-load-warning"><span class="fa fa-exclamation-triangle">&nbsp;</span>%message%</div>',
    offersTemplate: '<a href="%url%" class="product-other-offers" target="_blank">%message%</a>',
    attributeTemplate: '<span class="product-attribute %css_class%" title="%value%"><strong>%label%</strong>&nbsp;<span class="small">%value%</span></span>',

    itemUrl: 'ab/product/productsInfoByAsins/',
    pdpUrl: 'catalog/product/view/id/',
    maxLoadAttempts: 5,

    msgSeeMoreOffers: bq.messages.ab.seeMoreOffers,
    msgSeeMoreOffersNum: bq.messages.ab.seeMoreOffersNum,

    baseUrl: bq.global.baseUrl,
    jwt: bq.config.ab.jwt,

    /**
     * @param array  skus
     * @param object qtyBySku quantity to request the offers for, keyed by sku - Amazon prices an
     *               offer per ordered quantity, so the price depends on what is sent here
     */
    amazonProductMount: function (skus, qtyBySku) {
        this._throwEventLoadStart();

        var _this = this,
            d = $.Deferred();

        $.post(this.getLoadUrl(), {sku: skus, min_qty: qtyBySku})
            .done(function (json) {
                //One more attempt to load a product from Amazon Business
                if (json.error && json.code && json.code === 429 && _this.loadAttempts < _this.options.maxLoadAttempts) {
                    _this.retry(skus, qtyBySku);
                    //Handle different errors depends on the code field
                } else if (json.error && json.code && (json.code === 429)) {
                    _this.error(bq.messages.ab.errorApiExhausted);
                    d.reject(json);
                } else if (json.error && json.code && (json.code === 404)) {
                    _this.error(bq.messages.ab.errorProductNotFound);
                    d.reject(json);
                } else if (json.error) {
                    _this.error(bq.messages.ab.errorProductLoad);
                    d.reject(json);
                } else {
                    //merged, not replaced - a single row reloading its own sku must not drop the rest
                    bq.productSourceAmazon.prototype.initData = $.extend(
                        bq.productSourceAmazon.prototype.initData || {},
                        JSON.parse(json)
                    );
                    d.resolve(json);
                }
            })
            .fail(function (jqxhr, textStatus, error) {
                _this.error(bq.messages.ab.errorProductLoad, error);
                d.reject(error);
            })
            .always(function () {
                _this._throwEventLoadEnd();
            });
        return d;
    },

    getLoadUrl: function () {
        return this.baseUrl + this.itemUrl + 'jwt/' + encodeURI(this.jwt);
    },

    _throwEventLoadStart: function () {
        bq.helper.throwEvent('bq.viewhandler.start', $('body'))
    },

    _throwEventLoadEnd: function () {
        bq.helper.throwEvent('bq.viewhandler.stop', $('body'))
    },
};

bq.productSourceAmazon.prototype = {
    init: function() {
        if (this.isAmazonMountAllowed()) {
            this.updateData(this.initData);
        }
        return this;
    },

    reload: function(qty) {
        var _this = this;

        qty = parseInt(qty, 10);
        if (!this.isAmazonMountAllowed() || !(qty > 0)) {
            return this;
        }

        clearTimeout(this.qtyChangeTimer);
        this.qtyChangeTimer = setTimeout(function() {
            _this.reloadNow(qty);
        }, this.options.qtyChangeDelay);

        return this;
    },

    reloadNow: function(qty) {
        var _this = this,
            sku = this.sku,
            qtyBySku = {},
            request = ++this.reloadRequests;

        qtyBySku[sku] = qty;

        $('.product-load-warning', this.$errorContainer).remove();
        this.loading(true);

        this.options.amazonProductMount.call(this.options, [sku], qtyBySku)
            .done(function(json) {
                var data = JSON.parse(json);
                if (request !== _this.reloadRequests) {
                    return;
                }

                if (!data[sku] || !data[sku].price) {
                    _this.error(bq.messages.ab.errorProductLoad);
                    return;
                }

                _this.addPrice(data[sku].price);
            })
            .always(function() {
                if (request === _this.reloadRequests) {
                    _this.loading(false);
                }
            });

        return this;
    },

    isAmazonMountAllowed: function() {
        return (this.isAmazon && this.isLoadAllowed && (typeof this.sku  === 'string') && this.sku.length);
    },

    retry: function(skus, qty) {
        this.loadAttempts++;
        this.amazonProductMount(skus, qty);
        return this;
    },

    error: function(msg, err) {
        this.loaded = true;
        this.errorHappened = true;
        this.errorMessage = msg;

        if (!!err) {
            bq.debug.error(err);
        }

        //this.addOffers();
        this.addErrorMessage(msg);
        this.loading(false);

        return this;
    },

    updateData: function(data) {
        this.loaded = true;
        this.errorHappened = false;
        this.errorMessage = null;

        var sku = this.$element.data().productInfo.supplier_sku;
        if (!data[sku]) {
            return;
        }

        this.addPrice(data[sku].price);
        this.addOffers(parseInt(data[sku].offers_count));
        this.addAttributes(data[sku]);

        return this;
    },

    addErrorMessage: function(msg) {
        if (this.$errorContainer.length) {
            this.$errorContainer.append(
                this.options.errorTemplate.replace(/%message%/g, msg)
            );
        }
        return this;
    },

    addOffers: function(num) {
        var msg = this.options.msgSeeMoreOffers;
        if (this.$offersContainer.length) {
            this.$offersContainer.append(
                this.options.offersTemplate
                    .replace(/%url%/g, this.getSeeMoreOffersUrl())
                    .replace(/%message%/g, msg)
            );
        }

        return this;
    },

    addPrice: function(innerHtml) {
        var $priceEl = $('span.price', this.$priceContainer);
        if ($priceEl.length) {
            $priceEl.replaceWith(innerHtml);
        } else if (this.$priceContainer.length) {
            this.$priceContainer.html(innerHtml);
        }

        return this;
    },

    addAttributes: function(data) {
        if (!this.$attributesContainer || !this.$attributesContainer.length) {
            return this;
        }

        var attributes = [];

        if (data.condition) {
            attributes.push({
                label: bq.messages.ab.msgProductCondition,
                value: data.condition,
                css_class: 'amazon amazon-condition'
            });
        }

        if (data.availability) {
            attributes.push({
                label: bq.messages.ab.msgProductAvailability,
                value: data.availability,
                css_class: 'amazon amazon-availability'
            });
        }

        if (attributes.length) {
            var _this = this;
            attributes.forEach( function(a) {
                _this.$attributesContainer.append(
                    _this.renderAttribute(a)
                )
            });
        }

        return this;
    },

    renderAttribute: function(attribute) {
        return this.options.attributeTemplate
            .replace(/%css_class%/g, attribute.css_class)
            .replace(/%value%/g, attribute.value)
            .replace(/%label%/g, attribute.label);
    },

    getSeeMoreOffersUrl: function() {
        return this.options.baseUrl + this.options.pdpUrl + this.productId + '/offers/1';
    },

    loading: function(flag) {
        if (flag) {
            this.$element.addClass('item-loading');
            this.$children.prop('disabled', true);
        } else {
            this.$element.removeClass('item-loading');
            this.$children.prop('disabled', false);
        }
    },

    getProduct: function() {
        var product = this.$element.data('productInfo');
        if (typeof(product) === "string") {
            try {
                product = $.parseJSON(product);
            } catch(ex) {
                bq.debug.error("productSourceAmazon : error parsing data-product-info", ex);
                product = {}; //error parsing json, make blank
            }
        }
        return product;
    }
};


// LOAD BLOCK PLUGIN DEFINITION
// =======================
var productSourceAmazonold = $.fn.productSourceAmazon;

$.fn.productSourceAmazon = function (option) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.productSourceAmazon');
        var options = $.extend({}, bq.productSourceAmazon.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.productSourceAmazon', (data = new bq.productSourceAmazon(this, options))); }
        data.init();
    });
};

$.fn.productSourceAmazon.Constructor = bq.productSourceAmazon;

// LOAD BLOCK NO CONFLICT
// =================

$.fn.productSourceAmazon.noConflict = function () {
    $.fn.productSourceAmazon = productSourceAmazonold;
    return this;
};

// LOAD BLOCK DATA-API
// ==============

bq.productSourceAmazonBindQtyChange = function() {
    let selector = bq.productSourceAmazon.DEFAULTS.qtyInputSelector;
    if (!selector) { return; }

    $(document)
        .off('change.bq.productSourceAmazon', selector)
        .on('change.bq.productSourceAmazon', selector, function () {
            let instance = $(this).closest('[data-product-info]').data('bq.productSourceAmazon');
            if (instance) { instance.reload($(this).val()); }
        });
};

bq.productSourceAmazonInit = function() {
    let products = $('[data-product-info]');
    if (products.data('bq.productSourceAmazon') || !products.length) { return; }

    bq.productSourceAmazonBindQtyChange();

    function getAllSku() {
        let sku = [];
        products.each(function () {
            sku.push($(this).data().productInfo.supplier_sku);
        });

        return sku;
    }

    function getQtyBySku() {
        let qty = {};
        products.each(function () {
            let product = $(this).data().productInfo;
            if (product.requested_product_qty) {
                qty[product.supplier_sku] = product.requested_product_qty;
            }
        });

        return qty;
    }

    bq.productSourceAmazon.DEFAULTS.amazonProductMount(getAllSku(), getQtyBySku()).done(function() {
        products.each(function () {
            let el = $(this);
            if (el.data('bq.productSourceAmazon')) { return; }
            el.productSourceAmazon(el.data());
        });
    });
};

bq.init.push(bq.productSourceAmazonInit);
